import React from "react";
import './Support.css'

function Support() {
  return (
    <div className="container">
      
        <h1>Support Us</h1>
        <p>
          If you have any need or assistane, feel free to reach out to our
          support team. We are here to help!
        </p>
     
    </div>
  );
}

export default Support;
